<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/unlink-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Desvincular cuenta Outlook</h4></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <div class="text-center text-light mt-4">
                <h5>¿Estás seguro que quieres desvincular tu cuenta de <br> outlook <b>{{outlookEmail}}</b>?</h5>
            </div>
            <hr class="mt-5 mb-5">
            <div class="d-flex flex-row justify-center gap-20 mt-2">
                <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                <button class="btn btn-primary text-center" (click)="unlinkOutlook()">Desvincular cuenta</button>
            </div>
        </div>
    </div>
</div>